<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidadeRaizen',
    componentOptions: {
        title: 'Rastreabilidade',
        actions: [
            [
                {
                    name: 'Rastreabilidade',
                    iconClass: 'lyra-icon lyra-marcador',
                    showView: false,
                    action: 'abrirRastreabilidade',
                    route: 'RastreabilidadeRaizen'
                }
            ]
        ]
    },

    methods: {
        abrirRastreabilidade() {
            if (this.$route.name !== 'RastreabilidadeRaizen') {
                this.$router.push({ name: 'RastreabilidadeRaizen' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
